module.exports = "mat-dialog-content{width:450px}.spinner{float:left;height:25px;width:25px;margin-top:3px;margin-right:10px}.btn-cancel{margin-left:12px}"